
<template>
  <div>
    <h3>{{$t("articles.form.edit_articles.headers.title")}}</h3>
    <p>{{$t("articles.form.edit_articles.headers.text")}}</p>
    <div class="form form--sidepanel" >
      <div
        v-if="permissionAssignArticles !== 'no' && editCoderEnabled"
        class="form-group"
      >
        <label for="coder-id">{{$t("articles.form.edit_articles.labels.coder")}}</label>
        <input-select
          name="coder-id"
          :options="coderOptions"
          :selectedValue="coderOptions[0]"
          :onChange="(value) => onChangeField('coder_id', value)"
          :searchable="true"
        />
      </div>

      <div class="form-group">
        <label for="status-id">{{$t("articles.form.edit_articles.labels.status")}}</label>
        <input-select
          name="status-id"
          :options="statusOptions"
          :onChange="(value) => onChangeField('status_id', value)"
          :searchable="true"
        />
      </div>

      <div class="form-group">
        <label for="due-date">{{$t("articles.form.edit_articles.labels.due_date")}}</label>
        <datepicker
          name="due-date"
          :value="null"
          format="dd MMM yyyy"
          :minimum="new Date()"
          :onChange="(value) => onChangeField('due_date', value)"
          :clearButton="true"
        />
      </div>

      <!-- this must be in his own component -->
      <div class="mentions">
        <div class="form-group">
          <button type="submit" class="btn btn-default btn-sm mr10" @click="showMention(false)">{{$t("articles.form.edit_articles.actions.add_mentions")}}</button>
          <button type="submit" class="btn btn-default btn-sm mr10" @click="showMention(true)" >{{$t("articles.form.edit_articles.actions.remove_mentions")}}</button>
          <button type="submit" class="btn btn-default btn-sm mr10" @click="showDeleteOrganization(true)" >{{$t("articles.form.edit_articles.actions.remove_organization")}}</button>
        </div>
        <template v-if="showMentionForm">
          <h4 v-if="!deleteMentions">{{$t("articles.form.edit_articles.headers.add_mentions")}}</h4>
          <h4 v-else>{{$t("articles.form.edit_articles.headers.remove_mentions")}}</h4>
          <div v-if="!deleteMentions" class="alert alert-warning">
            <i class="fas fa-exclamation-circle"></i>
            {{ $t('articles.warning.mentions_add') }}
          </div>
          <div class="row">
            <div class="flex-2">
              <div v-if="hasOrganizationsCategory" class="form-group">
                <label for>{{$t("articles.form.edit_articles.labels.parent_tag")}}</label>
                <input-select
                  name="parent_tag_id"
                  ref="parent_tag_id"
                  :options="parentTagsOptions"
                  :selectedValue="parentTagsOptions[0] ? parentTagsOptions[0].value : null"
                  :onChange="(value) =>{ 
                    onParentTagChange(value);
                    onChangeField('parent_tag_id', value);
                  }"
                  :searchable="true"
                />
              </div>
              <div class="form-group">
                <label for>{{$t("articles.form.edit_articles.labels.organizations")}}</label>
                <input-select
                  name="organization_id"
                  ref="organization_id"
                  :options="organizationOptions"
                  :onChange="(value) => onChangeField('primary_tag_id', value)"
                  :searchable="true"
                  :onSearchChange="(searchText) => fetchOrganizations(searchText)"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex-2">
              <div class="form-group">
                <label>{{$t("articles.form.edit_articles.labels.category")}}</label>
                <input-select
                  name="child_category_id"
                  ref="child_category_id"
                  :options="filteredCategoryOptions"
                  :allowEmpty="false"
                  :onChange="(value) => selectTag(value)"
                  :searchable="true"
                  :onSearchChange="(searchText) => fetchCategoryTags(searchText)"
                />
              </div>
              <div class="form-group">
                <label>{{$t("articles.form.edit_articles.labels.tag")}}</label>
                <input-select
                  name="child_tag_id"
                  ref="child_tag_id"
                  :options="tagOptions"
                  :allowEmpty="false"
                  :selectedValue="tagOptions[0] ? tagOptions[0].value : null"
                  :onChange="(value) => onChangeField('mention', value)"
                  :onSearchChange="(search) => fetchSelectSourcesTags(this.selectedCategoryId,search)"
                  :loading="loadingTags"
                  :searchable="true"
                />
              </div>
            </div>
          </div>
        </template>

        <template v-if="showDeleteOrgForm">
          <h4 >{{$t("articles.form.edit_articles.headers.remove_organization")}}</h4>
          <div class="row">
            <div class="flex-2">
              <div v-if="hasOrganizationsCategory" class="form-group">
                <label for>{{$t("articles.form.edit_articles.labels.parent_tag")}}</label>
                <input-select
                  name="parent_tag_id_delete"
                  ref="parent_tag_id_delete"
                  :options="parentTagsOptions"
                  :onChange="(value) => onParentTagChange(value, true)"
                  :searchable="true"
                />
              </div>
              <div class="form-group">
                <label for>{{$t("articles.form.edit_articles.labels.organizations")}}</label>
                <input-select
                  name="organization_id"
                  ref="organization_id"
                  :options="organizationOptions"
                  :onChange="(value) => onChangeField('delete_organization_id', value)"
                  :searchable="true"
                  :onSearchChange="(searchText) => fetchOrganizations(searchText)"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
      <!--  -->

      <!-- this must be in his own component -->
      <div class="mentions">
        <button type="submit" class="btn btn-default btn-sm mr10" @click="showDuplicates()">{{$t("articles.form.edit_articles.actions.duplicate_mentions")}}</button>
        <template v-if="addDuplicates">
          <h4>{{$t("articles.form.edit_articles.headers.duplicate_mentions")}}</h4>
          <div class="alert alert-warning">
            <i class="fas fa-exclamation-circle"></i>
            {{ $t('articles.warning.mentions_duplicated') }}
          </div>
          <div class="row">
            <div class="flex-2">
              <div class="form-group full-flex-duplicate-mention">
                <label>{{$t("articles.form.edit_articles.labels.base_article")}}</label>
                <input-select
                  name="article_id"
                  ref="article_id"
                  :loading="articles_relationship_lines_busy"
                  :options="duplicateOptions"
                  :onChange="(value) => onChangeField('duplicate_codings', value)"
                />
              </div>
            </div>
          </div>
          <template>
            <div v-if="selectedArticleMentions.mentions">
              <div v-if="selectedArticleMentions.mentions.length > 0">
                <mention :primary_tag="mention" :allowDelete="false" v-for="(mention , index) in selectedArticleMentions.mentions" :key="index"/>
              </div>
            </div>
          </template>
        </template>
      </div>
      <!--  -->
      <template v-if="hasSharedMentions">
        <h4>{{$t("articles.form.edit_articles.headers.shared_mentions")}}</h4>
        <mention
          :primary_tag="sharedMentions"
          :allowDelete="true"
          :OnDeleteMentionTag="(value) => submitDeleteMention(value)"
          :showSharedMentions="true"
        />
      </template>
      <div>
        <password-prompt ref="prompt" @isValid="(val)=> isValid(val)" authAction="edit_articles" />
      </div>
      <div class="form-group" :class="{'form-footer': actionTarget === 'selected'}">
        <p v-if="formErrors" class="error">{{formErrors}}</p>
        <button type="submit" :disabled="!passwordValid || validating" class="btn btn-carma btn-sm" @click="(e) => onSubmitForm(e)">
          <i v-if="validating" class="fas fa-spinner rotate" ></i>
          {{ $t("messages.confirm_update.update_articles")}}
        </button>
      </div>
    </div>
    <confirmation-modal v-if="showConfirmation"
      :headerText="this.$t(`articles.form.edit_articles.modals.delete_title`)"
      :message="this.$tc(`articles.form.edit_articles.modals.organization_delete_message`, organizationName, { organization: organizationName, total: totalArticles })"
      :showDeleteButton="false"
      :force-tab-index="true"
      @confirmAction="(e) => onSubmitForm(e, true)"
      @cancelAction="() => { showConfirmation = false;}" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapState } from 'vuex';
import InputSelect from "../form-components/input-select";
import Datepicker from "../datepicker";
import Mention from "./mention";
import {CATEGORY_TYPES} from "../../config/const";
import PasswordPrompt from '../password-prompt';
import _ from "lodash"
import ConfirmationModal from '@/components/confirmation-modal';
import FormHelper from '@/helpers/form';

export default {
  props: {
    articles: Array,
    onSubmit: Function,
    coders: Array,
    editCoderEnabled: Boolean,
    outlets: Array,
    article_states: Array,
    organizations: Array,
    categories_tags: Array,
    articles_relationship_lines: Array,
    articles_relationship_lines_busy: Boolean,
    onSubmitDeleteMention: Function,
    actionTarget: {
      type: String,
      required: false,
      default: 'selected',
      validation: (value) => {
        return ['selected','filtered'].indexOf(value) !== -1;
      }
    }
  },

  created: function(){
    this.CATEGORY_TYPES = CATEGORY_TYPES;
  },
  
  mounted: function() {
    // Fetch mention types if project has organizations_category_id
    if (this.hasOrganizationsCategory) {
      this.fetchParentTags();
    }
  },

  computed: {
    ...mapGetters('user', ['permissionAssignArticles']),
    ...mapState({
      project: state => state.projects.project.data,
    }),
    hasOrganizationsCategory: function() {
      return this.project?.organizations_category_id && this.project?.organizations_with_category;
    },
    organizationsCategoryId: function() {
      return this.project?.organizations_category_id;
    },
    parentTagsOptions: function() {
      return this.fetchedParentTags.map(t => ({ value: t.id, label: t.name }));
    },
    coderOptions: function() {
      return this.coders.map((c, i) => ({ value: c.id, label: c.name }));
    },
    outletOptions: function() {
      return this.outlets.map(o => ({ value: o.id, label: o.name }));
    },
    statusOptions: function() {
      return this.article_states.map(s => ({ value: s.id, label: s.status }));
    },
    organizationOptions: function() {
      return this.organizations.map(o => ({ value: o.id, label: o.name }));
    },
    tagOptions: function() {
      const category = this.categories_tags.find(c => c.id === this.selectedCategoryId);
      return this.tags[0]
        ? this.tags.map(t => ({ value: t, label: this.CATEGORY_TYPES.SOURCE == category.category_type_id ? `${t.first_name} ${t.last_name}`.trim() : t.name }))
        : [];
    },
    //  duplicate options
    duplicateOptions: function() {
      return this.articles_relationship_lines.map(arl => {
        return {
          value: arl,
          label: arl.label
        };
      });
    },
    selectedArticleMentions: function() {
      return this.article.duplicate_codings
        ? this.article.duplicate_codings
        : {};
    },
    sharedMentions: function() {
      let sharedMentions = { tags: [], sources: [], organizations: [] };

      let sharedTags = this.articles_relationship_lines.map(({ mentions }) => {
        let tags = [];
        mentions
          .map(m => {
            return m.tags;
          })
          .forEach(t => {
            t.forEach(t2 => {
              tags.push({ id: t2.id, name: t2.name, color: t2.color });
            });
          });
        return [...new Set(tags)];
      });

      let sharedSources = this.articles_relationship_lines.map(
        ({ mentions }) => {
          let sources = [];
          mentions
            .map(m => {
              return m.sources;
            })
            .forEach(t => {
              t.forEach(t2 => {
                sources.push({ id: t2.id, name: t2.name, color: t2.color });
              });
            });
          return [...new Set(sources)];
        }
      );

      let sharedOrganizations = this.articles_relationship_lines.map(
        ({ mentions }) => {
          return mentions.map(m => ({
            id: m.organization_id,
            name: m.name,
            color: m.color
          }));
        }
      );

      if (sharedOrganizations.length > 0) {
        let organizations = sharedOrganizations.reduce((a, b) =>
          a.filter(c => b.some(b => c.id === b.id))
        );
        sharedMentions.organizations = organizations;
      }

      if (sharedTags.length > 0) {
        let tags = sharedTags.reduce((a, b) =>
          a.filter(c => b.some(b => b.id === c.id))
        );
        sharedMentions.tags = tags;
      }

      if (sharedSources.length > 0) {
        let sources = sharedSources.reduce((a, b) =>
          a.filter(c => b.some(b => b.id === c.id))
        );
        sharedMentions.sources = sources;
      }

      return sharedMentions;
    },

    hasSharedMentions: function () {
      return this.actionTarget === 'selected' && (this.sharedMentions.tags.length > 0 || this.sharedMentions.sources.length > 0 || this.sharedMentions.organizations.length > 0);
    },

    categoryTagsOptionsCombineWatch() {
      return {
        categories_tags: this.categories_tags,
        primary_tag_id: this.article.primary_tag_id
      };
    }
  },

  watch: {
    tagOptions: {
      handler(options){
        if (options.length > 0) {
          this.onChangeField('mention', options[0].value);
        }
      }
    },

    selectedCategoryId: {
      handler(value){
        this.fetchSelectSourcesTags(value);
      }
    },

    categoryTagsOptionsCombineWatch: {
      handler() {
        this.filteredCategoryOptions = this.categoryOptions();
      },
      deep: true,
    },
    
    hasOrganizationsCategory: {
      handler(newVal) {
        if (newVal) {
          this.fetchParentTags();
        } else {
          this.fetchedParentTags = [];
          this.selectedParentTagId = null;
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      getCategoryTags: "projectSetup/getCategoryTags",
      getCategorySources: "projectSetup/getCategorySources",
      getOrganizations: "articles/getOrganizations",
      getCategories: "articles/getCategories",
    }),
    onChangeField: function(field, value) {
      this.article = {
        ...this.article,
        [field]: value
      };

      if (field.trim().toLowerCase() === "primary_tag_id" && !_.isEmpty(this.categoryOptions) ) {
        this.$refs.child_category_id._vnode.context.selected = this.categoryOptions[0];
        this.selectTag(this.categoryOptions[0].value);
      }
    },

    selectTag: function(category_id) {
      this.selectedCategoryId = category_id;
    },

    showMention(isDeleteMentions) {
      this.showDeleteOrganization(false);
      this.showMentionForm =
        this.deleteMentions === isDeleteMentions && this.showMentionForm
          ? false
          : true;

      this.deleteMentions = isDeleteMentions;
      this.article.delete_mentions = isDeleteMentions;

      if (!this.showMentionForm) this.clearMentionsData();
    },

    showDeleteOrganization(val) {
      this.showMentionForm = false;
      this.showDeleteOrgForm = val;
    },

    clearMentionsData() {
      this.$delete(this.article, "primary_tag_id");
      this.$delete(this.article, "mention");
      this.$delete(this.article, "delete_mentions");
      this.selectTag(null);
    },

    showDuplicates: function() {
      this.addDuplicates = this.addDuplicates === false ? true : false;
      if (!this.addDuplicate) {
        this.$delete(this.article, "duplicate_codings");
      }
    },

    onSubmitForm: async function(event, skipConfirmation = false) {
      if(!skipConfirmation && this.article.delete_organization_id){
        this.organizationName = this.organizations.find(o=> o.id === this.article.delete_organization_id).name
        this.showConfirmation = true;
        return; 
      }
      this.formErrors = "";
      let changes = {};
      Object.entries(this.article)
        .filter(k => k[1] != null)
        .forEach(k => {
          changes[k[0]] = k[1];
        });
        try {
          this.validating = true;
          await this.$refs.prompt.validate();
          if (Object.entries(changes).length > 0) {
            this.onSubmit(this.article);
          } else {
            this.formErrors = this.$t("messages.confirm_update.update_articles_error");
          }
        } catch (error) {
            Vue.notify({
              group: "store_notifications",
              type: "error",
              text: this.$t("messages.confirm_delete.password_confirm_error")
            })
        } finally {
          this.validating = false;
        }
    },

    submitDeleteMention: function(mention) {
      this.onSubmitDeleteMention(mention);
    },

    isValid (val) {
      this.passwordValid = val;
    },

    isValidating(val) {
      this.validating = val;
    },

    fetchSelectSourcesTags(categoryId, search = '') {
      if(categoryId){
        const category = this.categories_tags.find(c => c.id === categoryId);
        const params = { 
          projectUid: this.$route.params.project_uid, 
          categoryId: categoryId, 
          pagination: { page: 1, perPage: 100, filter: search },
          filters: { skip_article_count: true }
        };
        this.loadingTags = true;
        this.tags = [];
        if (category.category_type_id === CATEGORY_TYPES.SOURCE) {
          this.getCategorySources(params).then(r => {
            this.tags = r;
            this.loadingTags = false;
          });
        } else {
          this.getCategoryTags(params).then(r => {
            this.tags = r;
            this.loadingTags = false;
          });
        }
      }
    },

    fetchOrganizations(value){
      const params = { 
        projectId: this.$route.params.project_uid, 
        pagination: { page: 1, perPage: 20, order: 'name', sort: 'DESC', search_query: value}
      };
      
      // If project has organizations_category_id and a mention type is selected, filter by parent_tag_id
      if (this.hasOrganizationsCategory && this.selectedParentTagId) {
        params.pagination.category_id = this.selectedParentTagId;
      }
      
      FormHelper.delayFunction(this.getOrganizations(params), 500, this);
    },
    
    onParentTagChange(value) {
      this.selectedParentTagId = value;
      // Clear organizations and refetch with the new filter
      this.$store.commit('articles/LOAD_ORGANIZATIONS_SUCCESS', { data: { data: [], pagination: {} } });
      this.fetchOrganizations('');
    },
    
    async fetchParentTags() {
      if (!this.hasOrganizationsCategory) {
        return;
      }
      
      const params = { 
        projectUid: this.$route.params.project_uid, 
        categoryId: this.organizationsCategoryId, 
        pagination: { page: 1, perPage: 100 },
        filters: { skip_article_count: true }
      };
      
      try {
        if(this.hasOrganizationsCategory && (!this.fetchedParentTags || this.fetchedParentTags.length === 0)) {
          const tags = await this.getCategoryTags(params);
          this.fetchedParentTags = tags || [];
          // Auto-select first mention type if available
          if (this.fetchedParentTags.length > 0) {
            this.selectedParentTagId = this.fetchedParentTags[0].id;
            this.fetchOrganizations('');
          }
        }
      } catch (error) {
        console.error('Error fetching mention types:', error);
      }
    },

    categoryOptions () {
        return this.categories_tags.filter(c => {
          let filterType;
          if (!_.isEmpty(this.article) && this.article.primary_tag_id) { // Filter article_level and grouping tags depending on whether an organization was selected
            filterType = [CATEGORY_TYPES.GROUPING, CATEGORY_TYPES.ARTICLE_FEATURE, CATEGORY_TYPES.MEDIA_TAG].indexOf(c.category_type_id) === -1 && c.category_type_id !== CATEGORY_TYPES.ORGANIZATION;
          } else {
            filterType = [CATEGORY_TYPES.ARTICLE_FEATURE, CATEGORY_TYPES.MEDIA_TAG].indexOf(c.category_type_id) > -1;
          }
          // Also filter mentions categories without tags and organization tags
          return ((filterType && c.tags_count > 0 && c.category_type_id !== CATEGORY_TYPES.ORGANIZATION) && c.id !== this.project?.organizations_category_id)
        }).map(c => ({ value: c.id, label: c.name }));
    },

    fetchCategoryTags(value){
      const params = { projectUid: this.$route.params.project_uid, pagination: { page: 1, perPage: 20, search: value } };
      FormHelper.delayFunction(this.getCategories(params), 500, this);
    }
  },

  data: function() {
    return {
      article: {},
      showMentionForm: false,
      deleteMentions: false,
      addDuplicates: false,
      tags: [],
      formErrors: "",
      isDeleteMentions: false,
      validating: false,
      passwordValid: false,
      loadingTags: false,
      selectedCategoryId: null,
      showDeleteOrgForm: false,
      showConfirmation: false,
      organizationName: '',
      totalArticles: this.articles?.length || 0,
      filteredCategoryOptions: [],
      fetchedParentTags: [],
      selectedParentTagId: null,
      loadingOrganizations: false
    };
  },

  components: {
    InputSelect,
    Datepicker,
    Mention,
    PasswordPrompt,
    ConfirmationModal
  }
};
</script>


<style lang="scss" scoped>
@import "../../styles/components/form";
//@import "../../styles/components/admin/tags.scss";

:deep(.dp-wrapper) {
  padding: 0;

  .dp-input {
    height: 32px;
    width: 100%;
    padding: 4px 10px;

    @include input-text;
    @include placeholder;
  }

  .vdp-datepicker__clear-button {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
  }
}

:deep(.multiselect) {
  &.multiselect--active .multiselect__placeholder {
    display: block;
  }

  .multiselect__tags {
    .multiselect__input,
    .multiselect__single {
      @include input-text;
      @include placeholder;
    }
  }
}

.error {
  color: $state-danger-text;
  font-size: $base-font-size;
  margin: 20px 0 0;
}

.mentions {
  button {
    font-size: 13px;
  }

  label {
    font-size: 13px;
  }

  .row {
    display: flex;
    align-items: center;

    .flex-2 {
      display: flex;
      align-items: flex-start;
      flex: 1 1 auto;
      margin: 0 -10px;
      .form-group {
        padding: 0 10px;
        flex: 0 0 50%;
      }
      .full-flex-duplicate-mention {
        flex: 0 0 100%;
      }
    }
  }
}
</style>